<template>
  <a-layout>
    <a-layout-content :style="{ backgroundColor: 'white' }">
      <a-table
        row-key="id"
        :data-source="tableData"
        :pagination="pagination"
        :loading="loading"
      >
        <a-table-column title="qq" data-index="qq" />
        <a-table-column title="昵称" data-index="nickname" />
        <a-table-column title="上次发言时间" data-index="last_send_time">
          <template slot-scope="text">
            {{ $FormatUtil.timestamp2date(text) }}
          </template>
        </a-table-column>
        <a-table-column title="状态">
          <template slot-scope="record">
            <a-tag v-if="record.out_time === 0">正常</a-tag>
            <a-tag v-else> {{ record.reason }}</a-tag>
          </template>
        </a-table-column>
      </a-table>
      <!--编辑任务量-->
      <Top></Top>
    </a-layout-content>
  </a-layout>
</template>

<script>
import Top from '@/components/top'
import { get_group_member_list } from '@/api/qq'

export default {
  components: { Top },
  name: 'Member',
  data() {
    return {
      search: {
        username: '',
        code: '',
      },
      editModal: false,
      //修改窗口
      edit_id: 0,
      edit_task: 0,
      pForm: {
        num: 1,
        task: 9,
        promotion_id: undefined,
      },
      // table
      id: null /* 当前活动 id*/,
      tableData: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        onChange: (page) => {
          this.pagination.current = page
          this.getData()
        },
      },
      loading: false,
      downFileStatus: false,
      batchQrCodeStatus: false,
    }
  },
  mounted() {
    this.id = parseInt(this.$route.query.id)
    this.getData()
  },
  methods: {
    getData() {
      get_group_member_list({
        id: this.id,
        pageSize: this.pagination.pageSize,
        current: this.pagination.current,
      }).then((res) => {
        if (res['code'] === 1) {
          this.tableData = res.list
          this.pagination.total = res.total
        } else {
          this.$message.warning({
            content: res['msg'],
            key: 'get_group_member_list',
          })
        }
      })
    },
    onSearch() {
      this.pagination.total = 0
      this.pagination.current = 1

      this.getData()
    },
  },
}
</script>

<style></style>
